import {createContext, type PropsWithChildren, useContext, useMemo} from 'react'
import {useAuth} from '../auth/AuthContext'
import {KaldFlyteApiClient} from './client'

const ApiContext = createContext<KaldFlyteApiClient | null>(null)

export function ApiProvider({children}: PropsWithChildren) {
  const {token} = useAuth()
  const client = useMemo(() => new KaldFlyteApiClient(() => token), [token])
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>
}

export function useApi(): KaldFlyteApiClient {
  const client = useContext(ApiContext)
  if (!client) throw new Error('useApi must be used inside ApiProvider')
  return client
}
